// import React, { useCallback, useEffect, useState } from "react";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import {
//   Box,
//   Grid,
//   Typography,
//   Button,
//   styled,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
// } from "@mui/material";
// import { RxCross2 } from "react-icons/rx";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import { customTextColor } from "../../utils/const";
// import ViewCandidateDrawer from "./ViewCandidateDrawer";
// import CandidateRequestDrawer from "./CandidateRequestDrawer";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   deleteCandidate,
//   getCandidateList,
// } from "../../redux/hotlist/hotListSlice";
// import { allLocation } from "../../redux/common/locationSlice";
// import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
// import EditCandidateDrawer from "./EditCandidateDrawer";
// import CreateHotlistDrawer from "./CreateHotlistDrawer";
// import ShareHotlistDrawer from "./ShareHotlistDrawer";

// // Styled ActionButton component (reused from HotList)
// const ActionButton = styled(Button)(({ theme }) => ({
//   minWidth: "auto",
//   padding: theme.spacing(0.5),
//   backgroundColor: "#f0f0f0",
//   borderRadius: "4px",
//   "&:hover": {
//     backgroundColor: "#d0d0f0",
//   },
// }));

// const ViewEditHotlistDrawer = ({
//   show,
//   handleClose,
//   hotlist,
//   credit,
//   date,
// }) => {
//   const dispatch = useDispatch(); // Assuming you have a Redux store set up
//   const [showViewCandidateDrawer, setShowViewCandidateDrawer] = useState(false);
//   const [showRequestDrawer, setShowRequestDrawer] = useState(false);
//   const [showEditDrawer, setShowEditDrawer] = useState(false);
//   const [showAddDrawer, setShowAddDrawer] = useState(false);

//   const [selectedCandidateName, setSelectedCandidateName] = useState("");
//   const [openDialog, setOpenDialog] = useState(false);
//   const [showShareDrawer, setShowShareDrawer] = useState(false);
//   const [candidateToDelete, setCandidateToDelete] = useState(null);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const candidateList = useSelector((state) => state.hotlist.candidates);
//   const candidateListLoading = useSelector(
//     (state) => state.hotlist.loading.getCandidateList
//   );
//   const workautho = useSelector((state) => state.workautho);
//   const locations = useSelector((state) => state.location) || [];

//   console.log(candidateList, "candidateList", hotlist, candidateListLoading);

//   useEffect(() => {
//     hotlist?.id && dispatch(getCandidateList(hotlist?.id));
//   }, [dispatch, hotlist?.id]);

//   const handleCloseViewCandidateDrawer = () => {
//     setShowViewCandidateDrawer(false);
//   };

//   const handleCloseRequestDrawer = () => {
//     setShowRequestDrawer(false);
//   };

//   const handleOpenRequestDrawer = (candidateName) => {
//     setSelectedCandidateName(candidateName);
//     setShowRequestDrawer(true);
//   };

//   const handleOpenDialog = (candidate) => {
//     setCandidateToDelete(candidate);
//     setOpenDialog(true);
//   };

//   const handleConfirmDelete = async () => {
//     // Placeholder for delete logic (e.g., remove candidate from hotlistData)
//     console.log(`Deleted profile for ${candidateToDelete?.full_name}`);
//     await dispatch(deleteCandidate(candidateToDelete?.id)); // Assuming you have a delete action in your Redux slice
//     setOpenDialog(false);
//     setCandidateToDelete(null);
//   };

//   const handleCancelDelete = () => {
//     setOpenDialog(false);
//     setCandidateToDelete(null);
//   };

//   const getLocationById = (id) => {
//     let locationResult = locations?.data?.locations?.find(
//       (res) => res.id === id
//     );
//     return locationResult?.name;
//   };

//   const getWorkAuthorization = (id) => {
//     let authorizationResult = workautho?.data?.work_authorization_data?.find(
//       (res) => res.id === id
//     );
//     return authorizationResult?.name;
//   };
//   const getPreferLocationNames = (preferLocation) => {
//     return preferLocation
//       ?.map(
//         (id) =>
//           locations?.data?.locations?.find((location) => location.id === id)
//             ?.name
//       ) // Map IDs to names
//       ?.filter(Boolean) // Remove any undefined values if IDs don't match
//       ?.join(", "); // Join names with a comma and space
//   };

//   useEffect(() => {
//     dispatch(allLocation());
//     dispatch(allWorkAuthorization());
//   }, [dispatch]);

//   const handleEditCandidate = (candidate) => {
//     setSelectedCandidate(candidate);
//     setShowEditDrawer(true);
//   };

//   const handleCloseDrawer = () => {
//     setShowEditDrawer(false);
//     setSelectedCandidate(null);
//   };
//   const handleCloseAddDrawer = () => {
//     setShowAddDrawer(false);
//   };
//   const handleCloseShareDrawer = useCallback(() => {
//     setShowShareDrawer(false);
//   }, []);
//   return (
//     <Offcanvas
//       show={show}
//       onHide={handleClose}
//       placement="end"
//       scroll={true}
//       backdrop={false}
//       style={{
//         border: "none",
//         marginTop: "65px",
//         width: "55%",
//         boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
//         <Box sx={{ padding: "10px 15px" }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "0px 5px",
//               // borderBottom: "1px solid #e0e0e0",
//               mb: 2,
//             }}
//           >
//             <Box>
//               <Typography
//                 style={{
//                   color: customTextColor,
//                   fontWeight: "bold",
//                   fontSize: "18px",
//                 }}
//               >
//                 {hotlist.name}
//               </Typography>
//               <Typography style={{ color: customTextColor, fontSize: "14px" }}>
//                 {date}
//               </Typography>
//             </Box>
//             <Box sx={{ display: "flex", gap: "10px" }}>
//               <Box>
//                 <Typography
//                   style={{
//                     color: customTextColor,
//                     fontWeight: "bold",
//                     fontSize: "18px",
//                   }}
//                   variant="h5"
//                 >
//                   {credit}
//                 </Typography>
//                 <Typography
//                   style={{ color: customTextColor, marginTop: "-2px" }}
//                 >
//                   Credit Available
//                 </Typography>
//               </Box>

//               <RxCross2
//                 style={{
//                   fontSize: "15px",
//                   cursor: "pointer",
//                   color: customTextColor,
//                 }}
//                 onClick={handleClose}
//               />
//             </Box>
//           </Box>
//           {candidateListLoading === "pending" && (
//             <Box
//               sx={{ display: "flex", justifyContent: "center", mt: 2, py: 5 }}
//             >
//               {" "}
//               <CircularProgress />
//             </Box>
//           )}
//           {candidateListLoading !== "pending" &&
//             candidateList?.map((candidate, index) => (
//               <Grid
//                 container
//                 key={index}
//                 sx={{
//                   padding: "14px",
//                   mb: "10px",
//                   borderRadius: "3px",
//                   border: "1px solid #e0e0e0",
//                   alignItems: "center",
//                 }}
//               >
//                 {/* Left Column: Name, Job Profile, Current Location, Rate */}
//                 <Grid item xs={6}>
//                   <ul
//                     style={{
//                       listStyleType: "square",
//                       paddingLeft: "20px",
//                       margin: 0,
//                     }}
//                   >
//                     <li>
//                       <Typography style={{ fontSize: "14px" }}>
//                         Name: <b>{candidate.full_name}</b>
//                       </Typography>
//                     </li>
//                     <li>
//                       <Typography style={{ fontSize: "14px" }}>
//                         Job Profile: <b>{candidate.current_job_title}</b>
//                       </Typography>
//                     </li>
//                     <li>
//                       <Typography style={{ fontSize: "14px" }}>
//                         Current Location:{" "}
//                         <b>{getLocationById(candidate?.current_location)}</b>
//                       </Typography>
//                     </li>
//                     <li>
//                       <Typography style={{ fontSize: "14px" }}>
//                         Rate: <b>${candidate.rate} Hourly</b>
//                       </Typography>
//                     </li>
//                   </ul>
//                 </Grid>

//                 {/* Right Column: Visa, Experience, Prefer Location, Recent Job */}
//                 <Grid item xs={6}>
//                   <ul
//                     style={{
//                       listStyleType: "square",
//                       paddingLeft: "20px",
//                       margin: 0,
//                     }}
//                   >
//                     <li>
//                       <Typography style={{ fontSize: "14px" }}>
//                         Visa:{" "}
//                         <b>
//                           {getWorkAuthorization(candidate?.work_authorization)}
//                         </b>
//                       </Typography>
//                     </li>
//                     <li>
//                       <Typography style={{ fontSize: "14px" }}>
//                         Experience:{" "}
//                         <b>
//                           {candidate.total_experience < 1
//                             ? `${Math.round(
//                                 candidate.total_experience * 12
//                               )} Months`
//                             : `${candidate.total_experience} ${
//                                 candidate.total_experience === 1
//                                   ? "Year"
//                                   : "Years"
//                               }`}
//                         </b>
//                       </Typography>
//                     </li>
//                     <li>
//                       <Typography style={{ fontSize: "14px" }}>
//                         Prefer Location:{" "}
//                         <b>
//                           {getPreferLocationNames(candidate?.prefer_location)}
//                         </b>
//                       </Typography>
//                     </li>
//                     <li>
//                       <Typography style={{ fontSize: "14px" }}>
//                         Relocate:{" "}
//                         <b>{candidate?.willing_to_relocate ? "Yes" : "No"}</b>
//                       </Typography>
//                     </li>
//                   </ul>
//                 </Grid>

//                 {/* View More and Request Buttons */}
//                 <Grid
//                   item
//                   xs={6}
//                   sx={{
//                     display: "flex",
//                     justifyContent: "flex-start",
//                     gap: "10px",
//                     mt: "5px",
//                   }}
//                 >
//                   <Button
//                     variant="contained"
//                     sx={{
//                       marginTop: "5px",
//                       backgroundColor: "#d9d9d9",
//                       textTransform: "capitalize",
//                       borderRadius: "3px",
//                       boxShadow: "none",
//                       color: "#000",
//                       padding: "4px 8px",
//                       "&:hover": {
//                         backgroundColor: "#b8b8b8",
//                         boxShadow: "none",
//                       },
//                     }}
//                     onClick={() => {
//                       setShowViewCandidateDrawer(true);
//                       setSelectedCandidate(candidate);
//                     }}
//                   >
//                     View More
//                   </Button>
//                   <Button
//                     variant="contained"
//                     onClick={() => handleOpenRequestDrawer(candidate.name)}
//                     sx={{
//                       marginTop: "5px",
//                       backgroundColor: "#d9d9d9",
//                       textTransform: "capitalize",
//                       borderRadius: "3px",
//                       boxShadow: "none",
//                       color: "#000",
//                       padding: "4px 8px",
//                       "&:hover": {
//                         backgroundColor: "#b8b8b8",
//                         boxShadow: "none",
//                       },
//                     }}
//                   >
//                     Request 05
//                   </Button>
//                 </Grid>

//                 {/* Edit and Delete Icons */}
//                 <Grid
//                   item
//                   xs={6}
//                   sx={{
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     gap: "10px",
//                     mt: "5px",
//                   }}
//                 >
//                   <ActionButton
//                     color="inherit"
//                     onClick={() => handleEditCandidate(candidate)}
//                     sx={{
//                       backgroundColor: "#00b0f0",
//                       borderRadius: "3px",
//                       padding: "6px",
//                       "&:hover": {
//                         backgroundColor: "#33a8c7",
//                       },
//                     }}
//                   >
//                     <Icon
//                       icon="carbon:edit"
//                       width="20px"
//                       height="20px"
//                       color="#ffff"
//                     />
//                   </ActionButton>
//                   <ActionButton
//                     color="inherit"
//                     onClick={() => handleOpenDialog(candidate)}
//                     sx={{
//                       backgroundColor: "#e76f51",
//                       borderRadius: "3px",
//                       padding: "6px",
//                       "&:hover": {
//                         backgroundColor: "#d65a4a",
//                       },
//                     }}
//                   >
//                     <Icon
//                       icon="fluent:delete-24-regular"
//                       width="20px"
//                       height="20px"
//                       color="#ffff"
//                     />
//                   </ActionButton>
//                 </Grid>
//               </Grid>
//             ))}
//           {candidateListLoading !== "pending" && (
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: "10px",
//                 mb: "5px",
//                 alignItems: "center",
//               }}
//             >
//               <Button
//                 variant="contained"
//                 sx={{
//                   marginTop: "5px",
//                   backgroundColor: "#ffc107",
//                   color: "#000",
//                   textTransform: "capitalize",
//                   borderRadius: "3px",
//                   boxShadow: "none",
//                   "&:hover": {
//                     backgroundColor: "#e0a800",
//                     boxShadow: "none",
//                   },
//                 }}
//               >
//                 Re - Publish
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={() => setShowShareDrawer(true)}
//                 sx={{
//                   marginTop: "5px",
//                   backgroundColor: "#00b0f0",
//                   textTransform: "capitalize",
//                   borderRadius: "3px",
//                   boxShadow: "none",
//                   "&:hover": {
//                     backgroundColor: "#138496",
//                     boxShadow: "none",
//                   },
//                 }}
//               >
//                 Shared ({hotlist?.share_to_recruiter?.length})
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={() => setShowAddDrawer(true)}
//                 sx={{
//                   marginTop: "5px",
//                   backgroundColor: "#2e75b6",
//                   textTransform: "capitalize",
//                   borderRadius: "3px",
//                   boxShadow: "none",
//                   "&:hover": {
//                     backgroundColor: "#0056b3",
//                     boxShadow: "none",
//                   },
//                 }}
//               >
//                 Add More +
//               </Button>
//             </Box>
//           )}
//         </Box>

//         {/* ViewCandidateDrawer */}
//         <ViewCandidateDrawer
//           show={showViewCandidateDrawer}
//           handleClose={handleCloseViewCandidateDrawer}
//           selectedCandidate={selectedCandidate}
//         />
//         <CandidateRequestDrawer
//           show={showRequestDrawer}
//           handleClose={handleCloseRequestDrawer}
//           candidateName={selectedCandidateName}
//         />
//         {showEditDrawer && (
//           <EditCandidateDrawer
//             show={showEditDrawer}
//             handleClose={handleCloseDrawer}
//             candidate={selectedCandidate}
//             hotListId={hotlist?.id}
//             hotListTitle={hotlist?.name}
//           />
//         )}
//         {showAddDrawer && (
//           <CreateHotlistDrawer
//             show={showAddDrawer}
//             handleClose={handleCloseAddDrawer}
//             hotListID={hotlist?.id}
//             hotListTitle={hotlist?.name}
//           />
//         )}
//         {showShareDrawer && (
//           <ShareHotlistDrawer
//             show={showShareDrawer}
//             handleClose={handleCloseShareDrawer}
//             hotlist={hotlist}
//             credit={credit}
//           />
//         )}
//         {/* Delete Confirmation Dialog */}
//         <Dialog open={openDialog} onClose={handleCancelDelete}>
//           {/* <DialogTitle>Popup</DialogTitle> */}
//           <DialogContent>
//             <Typography>
//               Hi, {candidateToDelete?.full_name}. Are you sure, that you want to
//               delete this profile?
//             </Typography>
//           </DialogContent>
//           <DialogActions sx={{ mr: "14px", mb: "10px" }}>
//             <Button
//               variant="contained"
//               onClick={handleConfirmDelete}
//               sx={{
//                 backgroundColor: "#00b0f0",
//                 textTransform: "capitalize",
//                 borderRadius: "3px",
//                 boxShadow: "none",
//                 padding: "6px 14px",
//                 "&:hover": {
//                   backgroundColor: "#0085b4",
//                   boxShadow: "none",
//                 },
//               }}
//             >
//               Yes
//             </Button>
//             <Button
//               variant="contained"
//               onClick={handleCancelDelete}
//               sx={{
//                 backgroundColor: "#e76f51",
//                 textTransform: "capitalize",
//                 borderRadius: "3px",
//                 boxShadow: "none",
//                 padding: "6px 14px",
//                 "&:hover": {
//                   backgroundColor: "#d65a4a",
//                   boxShadow: "none",
//                 },
//               }}
//             >
//               No
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

// export default ViewEditHotlistDrawer;

import React, { useCallback, useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  Box,
  Grid,
  Typography,
  Button,
  styled,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { Icon } from "@iconify/react/dist/iconify.js";
import { customTextColor } from "../../utils/const";
import ViewCandidateDrawer from "./ViewCandidateDrawer";
import CandidateRequestDrawer from "./CandidateRequestDrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCandidate,
  getCandidateList,
  publishHotList,
} from "../../redux/hotlist/hotListSlice";
import { allLocation } from "../../redux/common/locationSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
import EditCandidateDrawer from "./EditCandidateDrawer";
import CreateHotlistDrawer from "./CreateHotlistDrawer";
import ShareHotlistDrawer from "./ShareHotlistDrawer";
import CandidateListDrawer from "./CandidateListDrawer";
import CreateHotListDraw from "./CreateHotListDraw";

// Styled ActionButton component (reused from HotList)
const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: theme.spacing(0.5),
  backgroundColor: "#f0f0f0",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#d0d0f0",
  },
}));

const ViewEditHotlistDrawer = ({
  show,
  handleClose,
  hotlist,
  credit,
  date,
}) => {
  const dispatch = useDispatch();
  const [showViewCandidateDrawer, setShowViewCandidateDrawer] = useState(false);
  const [showRequestDrawer, setShowRequestDrawer] = useState(false);
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [showShareDrawer, setShowShareDrawer] = useState(false);
  const [selectedCandidateName, setSelectedCandidateName] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [candidateToDelete, setCandidateToDelete] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [publishStatus, setPublishStatus] = useState(
    hotlist?.is_publish ? "publish" : "not_publish"
  );

  const candidateList = useSelector((state) => state.hotlist.candidates);
  const candidateListLoading = useSelector(
    (state) => state.hotlist.loading.getCandidateList
  );
  const publishHotListLoading = useSelector(
    (state) => state.hotlist.loading.publishHotList
  );
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  console.log(candidateList, "candidateList", hotlist, candidateListLoading);

  useEffect(() => {
    if (hotlist?.id) {
      dispatch(getCandidateList(hotlist.id));
    }
  }, [dispatch, hotlist?.id]);

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, [dispatch]);

  useEffect(() => {
    // Sync publishStatus with hotlist.is_publish when hotlist changes
    setPublishStatus(hotlist?.is_publish ? "publish" : "not_publish");
  }, [hotlist?.is_publish]);

  const handleCloseViewCandidateDrawer = () => {
    setShowViewCandidateDrawer(false);
  };

  const handleCloseRequestDrawer = () => {
    setShowRequestDrawer(false);
  };

  const handleOpenRequestDrawer = (candidate) => {
    console.log(candidate, "candidate");

    setSelectedCandidate(candidate);
    setShowRequestDrawer(true);
  };

  const handleOpenDialog = (candidate) => {
    setCandidateToDelete(candidate);
    setOpenDialog(true);
  };

  const handleConfirmDelete = async () => {
    console.log(`Deleted profile for ${candidateToDelete?.full_name}`);
    await dispatch(deleteCandidate(candidateToDelete?.id));
    setOpenDialog(false);
    setCandidateToDelete(null);
  };

  const handleCancelDelete = () => {
    setOpenDialog(false);
    setCandidateToDelete(null);
  };

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name || "N/A";
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name || "N/A";
  };

  const getPreferLocationNames = (preferLocation) => {
    return (
      preferLocation
        ?.map(
          (id) =>
            locations?.data?.locations?.find((location) => location.id === id)
              ?.name
        )
        ?.filter(Boolean)
        ?.join(", ") || "N/A"
    );
  };

  const handleEditCandidate = (candidate) => {
    setSelectedCandidate(candidate);
    setShowEditDrawer(true);
  };

  const handleCloseDrawer = () => {
    setShowEditDrawer(false);
    setSelectedCandidate(null);
  };

  const handleCloseAddDrawer = () => {
    setShowAddDrawer(false);
  };

  const handleCloseShareDrawer = useCallback(() => {
    setShowShareDrawer(false);
  }, []);

  const handlePublishChange = (event) => {
    const value = event.target.value;
    setPublishStatus(value);
    dispatch(
      publishHotList({
        hot_list_ids: [hotlist.id],
        is_publish: value === "publish",
      })
    );
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "55%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px 15px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 5px",
              mb: 2,
            }}
          >
            <Box>
              <Typography
                style={{
                  color: customTextColor,
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              >
                {hotlist.name}
              </Typography>
              <Typography style={{ color: customTextColor, fontSize: "14px" }}>
                {date}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Box>
                <Typography
                  style={{
                    color: customTextColor,
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                  variant="h5"
                >
                  {credit}
                </Typography>
                <Typography
                  style={{ color: customTextColor, marginTop: "-2px" }}
                >
                  Credit Available
                </Typography>
              </Box>
              <RxCross2
                style={{
                  fontSize: "15px",
                  cursor: "pointer",
                  color: customTextColor,
                }}
                onClick={handleClose}
              />
            </Box>
          </Box>
          {candidateListLoading === "pending" && (
            <Box
              sx={{ display: "flex", justifyContent: "center", mt: 2, py: 5 }}
            >
              <CircularProgress />
            </Box>
          )}
          {candidateListLoading !== "pending" &&
            candidateList?.map((candidate, index) => (
              <Grid
                container
                key={index}
                sx={{
                  padding: "14px",
                  mb: "10px",
                  borderRadius: "3px",
                  border: "1px solid #e0e0e0",
                  alignItems: "center",
                }}
              >
                <Grid item xs={6}>
                  <ul
                    style={{
                      listStyleType: "square",
                      paddingLeft: "20px",
                      margin: 0,
                    }}
                  >
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        Name: <b>{candidate.full_name}</b>
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        Job Profile: <b>{candidate.current_job_title}</b>
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        Current Location:{" "}
                        <b>{getLocationById(candidate?.current_location)}</b>
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        Rate: <b>${candidate.rate} Hourly</b>
                      </Typography>
                    </li>
                  </ul>
                </Grid>
                <Grid item xs={6}>
                  <ul
                    style={{
                      listStyleType: "square",
                      paddingLeft: "20px",
                      margin: 0,
                    }}
                  >
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        Visa:{" "}
                        <b>
                          {getWorkAuthorization(candidate?.work_authorization)}
                        </b>
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        Experience:{" "}
                        <b>
                          {candidate.total_experience < 1
                            ? `${Math.round(
                                candidate.total_experience * 12
                              )} Months`
                            : `${candidate.total_experience} ${
                                candidate.total_experience === 1
                                  ? "Year"
                                  : "Years"
                              }`}
                        </b>
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        Prefer Location:{" "}
                        <b>
                          {getPreferLocationNames(candidate?.prefer_location)}
                        </b>
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        Relocate:{" "}
                        <b>{candidate?.willing_to_relocate ? "Yes" : "No"}</b>
                      </Typography>
                    </li>
                  </ul>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: "10px",
                    mt: "5px",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      marginTop: "5px",
                      backgroundColor: "#d9d9d9",
                      textTransform: "capitalize",
                      borderRadius: "3px",
                      boxShadow: "none",
                      color: "#000",
                      padding: "4px 8px",
                      "&:hover": {
                        backgroundColor: "#b8b8b8",
                        boxShadow: "none",
                      },
                    }}
                    onClick={() => {
                      setShowViewCandidateDrawer(true);
                      setSelectedCandidate(candidate);
                    }}
                  >
                    View More
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleOpenRequestDrawer(candidate)}
                    sx={{
                      marginTop: "5px",
                      backgroundColor: "#d9d9d9",
                      textTransform: "capitalize",
                      borderRadius: "3px",
                      boxShadow: "none",
                      color: "#000",
                      padding: "4px 8px",
                      "&:hover": {
                        backgroundColor: "#b8b8b8",
                        boxShadow: "none",
                      },
                    }}
                  >
                    Request {candidate?.chat_recruiter_count}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    mt: "5px",
                  }}
                >
                  <ActionButton
                    color="inherit"
                    onClick={() => handleEditCandidate(candidate)}
                    sx={{
                      backgroundColor: "#00b0f0",
                      borderRadius: "3px",
                      padding: "6px",
                      "&:hover": {
                        backgroundColor: "#33a8c7",
                      },
                    }}
                  >
                    <Icon
                      icon="carbon:edit"
                      width="20px"
                      height="20px"
                      color="#ffff"
                    />
                  </ActionButton>
                  <ActionButton
                    color="inherit"
                    onClick={() => handleOpenDialog(candidate)}
                    sx={{
                      backgroundColor: "#e76f51",
                      borderRadius: "3px",
                      padding: "6px",
                      "&:hover": {
                        backgroundColor: "#d65a4a",
                      },
                    }}
                  >
                    <Icon
                      icon="fluent:delete-24-regular"
                      width="20px"
                      height="20px"
                      color="#ffff"
                    />
                  </ActionButton>
                </Grid>
              </Grid>
            ))}
          {candidateListLoading !== "pending" && (
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                mb: "5px",
                alignItems: "center",
              }}
            >
              <FormControl sx={{ minWidth: 120, marginTop: "5px" }}>
                {publishHotListLoading === "pending" ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "36px",
                      backgroundColor: "#d3d3d3",
                      borderRadius: "3px",
                    }}
                  >
                    <CircularProgress size={20} />
                  </Box>
                ) : (
                  <Select
                    value={publishStatus}
                    onChange={handlePublishChange}
                    disabled={publishHotListLoading === "pending"}
                    displayEmpty
                    sx={{
                      backgroundColor: "#d3d3d3",
                      color: "#000",
                      textTransform: "capitalize",
                      borderRadius: "3px",
                      boxShadow: "none",
                      height: "36px",
                      "&:hover": {
                        backgroundColor: "#c0c0c0",
                      },
                      "& .MuiSelect-select": {
                        padding: "8px 14px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    }}
                  >
                    <MenuItem value="publish">Publish</MenuItem>
                    <MenuItem value="not_publish">Not Publish</MenuItem>
                  </Select>
                )}
              </FormControl>
              <Button
                variant="contained"
                onClick={() => setShowShareDrawer(true)}
                sx={{
                  marginTop: "5px",
                  backgroundColor: "#00b0f0",
                  textTransform: "capitalize",
                  borderRadius: "3px",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#138496",
                    boxShadow: "none",
                  },
                }}
              >
                Shared ({hotlist?.share_to_recruiter?.length || 0})
              </Button>
              <Button
                variant="contained"
                onClick={() => setShowAddDrawer(true)}
                sx={{
                  marginTop: "5px",
                  backgroundColor: "#2e75b6",
                  textTransform: "capitalize",
                  borderRadius: "3px",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#0056b3",
                    boxShadow: "none",
                  },
                }}
              >
                Add More +
              </Button>
            </Box>
          )}
        </Box>
        <ViewCandidateDrawer
          show={showViewCandidateDrawer}
          handleClose={handleCloseViewCandidateDrawer}
          selectedCandidate={selectedCandidate}
        />
        {showRequestDrawer && (
          <CandidateRequestDrawer
            show={showRequestDrawer}
            handleClose={handleCloseRequestDrawer}
            candidateName={selectedCandidateName}
            candidate={selectedCandidate}
          />
        )}

        {showEditDrawer && (
          // <EditCandidateDrawer
          //   show={showEditDrawer}
          //   handleClose={handleCloseDrawer}
          //   candidate={selectedCandidate}
          //   hotListId={hotlist?.id}
          //   hotListTitle={hotlist?.name}
          // />

          <CreateHotListDraw
            show={showEditDrawer}
            handleClose={handleCloseDrawer}
            hotListName={hotlist?.name}
            selectedCandidate={selectedCandidate}
            hotListId={hotlist?.id}
            isEdit={true}
          />
        )}
        {showAddDrawer && (
          // <CreateHotlistDrawer
          //   show={showAddDrawer}
          //   handleClose={handleCloseAddDrawer}
          //   hotListID={hotlist?.id}
          //   hotListTitle={hotlist?.name}
          // />
          <CandidateListDrawer
            show={showAddDrawer}
            handleClose={handleCloseAddDrawer}
            hotListName={hotlist?.name}
            hotListId={hotlist?.id}
            // candidateList={candidateList}
          />
        )}
        {showShareDrawer && (
          <ShareHotlistDrawer
            show={showShareDrawer}
            handleClose={handleCloseShareDrawer}
            hotlist={hotlist}
            credit={credit}
          />
        )}
        <Dialog open={openDialog} onClose={handleCancelDelete}>
          <DialogContent>
            <Typography>
              Hi, {candidateToDelete?.full_name}. Are you sure, that you want to
              delete this profile?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ mr: "14px", mb: "10px" }}>
            <Button
              variant="contained"
              onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#00b0f0",
                textTransform: "capitalize",
                borderRadius: "3px",
                boxShadow: "none",
                padding: "6px 14px",
                "&:hover": {
                  backgroundColor: "#0085b4",
                  boxShadow: "none",
                },
              }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={handleCancelDelete}
              sx={{
                backgroundColor: "#e76f51",
                textTransform: "capitalize",
                borderRadius: "3px",
                boxShadow: "none",
                padding: "6px 14px",
                "&:hover": {
                  backgroundColor: "#d65a4a",
                  boxShadow: "none",
                },
              }}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewEditHotlistDrawer;
